export function notify(message, type = 'info', duration = 5000) {
  if (!message) return;

  // SSR/test guard
  const hasWindow = typeof window !== 'undefined';
  const hasDocument = typeof document !== 'undefined';

  // Preferred path: bubble an event that the app root handles
  if (hasWindow) {
    try {
      const event = new CustomEvent('show-notification', {
        detail: { message, type, duration },
        bubbles: true,
        composed: true
      });
      if (hasDocument) {
        document.dispatchEvent(event);
      } else if (typeof window.dispatchEvent === 'function') {
        window.dispatchEvent(event);
      }
    } catch {}
  }

  // Fallback: if global toast host is registered, call directly
  if (hasDocument) {
    const notifier = document.querySelector('toast-notifications') || (hasWindow && window.__toastNotifications);
    if (notifier && typeof notifier.show === 'function') {
      try { notifier.show(message, type, duration); } catch {}
    }
  }
}
